import React from 'react';
import './Toast.css';

const ICONS = {
  success: '✓',
  error: '✕',
  warning: '!',
  info: 'i',
};

const Toast = ({ message, type = 'info', onClose }) => {
  return (
    <div className={`toast toast-${type}`} role="alert">
      <span className="toast-icon">{ICONS[type] || ICONS.info}</span>
      <span className="toast-message">{message}</span>
      <button className="toast-close" onClick={onClose} aria-label="Close">&times;</button>
    </div>
  );
};

export default Toast;
